import * as PIXI from 'pixi.js';
import { Point } from "pixi.js";
import { PlayWindow } from "../../api";
import { ISystemContext } from "../../Context/SystemContext";
import { assertNotNullish } from "../../debug";
import { Log, Rect, Safe, Size } from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Settings } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { MyCanvas } from "../MyCanvas";
import { ReelSetMapper } from "../SpinAnimation/ReelSetMapper";
import { SpinAnimation } from "../SpinAnimation/SpinAnimation";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { S2_IReelConfig, S2_ISpinnableReelsParams, S2_SpinnableReelDisplayGeometry, S2_SpinnableReelsConfig, S2_SymbolTranslation } from "./SpinnableReels";

export interface S2_ISpinnableReelPIXI
{
	/*
	protected symbolSize: Size;

	public constructor(symbolSize: Size)
	{
		this.symbolSize = symbolSize;
	}

	public GetSymbolSize(): Size
	{
		return this.symbolSize;
	}
	*/

	Config: S2_IReelConfig;

	// rect of reel in pixels
	ReelRect: Rect;

	// the size of symbol in pixels
	SymbolSizeInPixels: Size;

	// reel window element with overhang
	ReelWindowElement: PIXI.Container;

	// hides borders while spinning
	SpinMaskElement: PIXI.Sprite;

	// reel window without overhang
	NormalizedWindowElement: PIXI.Container;
	
	BackgroundRect_symbols: Rect;
	BackgroundRect_pixels: Rect;
	WindowBackgroundElement: PIXI.Sprite;

	// this element gets translated, contains all canvases on reel
	ReelElement: PIXI.Container;

	// parts of reels
	TopHiddenSymbols: PIXI.Container;
	MiddleVisibleSymbols: PIXI.Container;
	BottomHiddenSymbols: PIXI.Container;

	Canvases: MyCanvas[];
	CanvasesPIXI : PIXI.Container[];

	//InflatedCanvasRect: PixelRect[];
	//OriginalCanvasRect: PixelRect[];

	// normalized to the canvas
	NormalizedOriginalCanvasRect: Rect;

	OriginalSymbolSize: Size;
	InflatedSymbolSize: Size;

	originalSymbolScaleX: number;
	originalSymbolScaleY: number;
	originalSymbolScale: number;

	inflatedSymbolScaleX: number;
	inflatedSymbolScaleY: number;
	inflatedSymbolScale: number;


	AbsoluteSymbolRects: Map<number, Rect>;

	ReelDisplayGeometry: S2_SpinnableReelDisplayGeometry;
}

export class S2_SpinnableReelsBigCanvas2 implements ISpinnableReels {
    
	// total window size in number of ymbols, including hidden symbols
	protected extendedWindowSymbolSize: Size = new Size();/**/


	// additional rows to add on tom of animation
	protected readonly numAdditionalRowsTop: number = 2;

	// TODO does not work for > 0, shifts symbols below in ReelSetMapper?
	protected readonly numAdditionalRowsBottom: number = 0;
	
	// size of one symbol. in pixels
	protected symbolSize: Size = new Size();

	protected centerOfReel: Point[] = [];

	
	protected slotWindowElement: HTMLElement = null;
	protected reelWindowElemsList: HTMLElement [] = [];
	public get ReelWindowElements(): HTMLElement[] 
	{
		return this.reelWindowElemsList;
	}

	protected reelElemsList: HTMLElement[] = [];
	public get ReelElements(): HTMLElement[]
	{
		return this.reelElemsList;
	}

	protected spinAnimation: SpinAnimation = null;
	protected reelSetMapper: ReelSetMapper = null;

	protected logGroup: string = "S2.SpinnableReels";

	// canvas element for each symbol
	// first index = reel index
	// second index = row index
	public canvas: MyCanvas[][] = [];
	public pixiContainercanvas: PIXI.Container[][] = [];
	public pixiCanvas: PIXI.Sprite[][] = [];

	/*

		+---+---+---+---+---+
		|   |           |   |
		+---+           +---+
		|   |           |   |
		+---+           +---+
		|   |           |   |
		+---+-----------+---+

	*/

	protected resid: ResourceIdentifier;
	protected config: S2_SpinnableReelsConfig = null;

	protected params: S2_ISpinnableReelsParams = null;

	protected animationColumns: number[];
	protected symbolElements: PIXI.Container[];
	protected symbolsInColumn: PIXI.Container[][];

	protected reels: S2_ISpinnableReelPIXI[];
	protected reelsInAnimationColumn: S2_ISpinnableReelPIXI[][];

	protected maxSymbolHeightInPixels: number = 0;
	protected maxReelHeightInSymbols: number = 0;

	protected systemContext: ISystemContext = null;
	//protected restoreWebGlInterval : IInterval = null;
	protected reelsCoverAnotherScreen : boolean = false;

	public constructor(resid: ResourceIdentifier, config: S2_SpinnableReelsConfig, params: S2_ISpinnableReelsParams = null, systemContext: ISystemContext, reelsCoverAnotherScreen : boolean = false) {
		this.resid = resid.Add("S2_SpinnableReelsBigCanvas2");
		this.config = config;
		this.systemContext = systemContext.CreateSubContext("S2_SpinnableReelsBigCanvas2");
		this.reelsCoverAnotherScreen = reelsCoverAnotherScreen;

		let defaultParams: S2_ISpinnableReelsParams = {
			windowRect: null,
			backgroundImage: null,
			bottomBorderWidth: 0,
			leftBorderWidth: 0,
			rightBorderWidth: 0,
			topBorderWidth: 0
		};

		this.params = {...defaultParams, ...params};
		

		// extended size, for hidden symbols on top
		this.extendedWindowSymbolSize = new Size(this.config.playWindow.Width, this.config.playWindow.Height + this.numAdditionalRowsTop + this.numAdditionalRowsBottom);
		//this.windowRect = windowRect;

		// find symbol size, based on window size and number of reels/rows
		//let windowInnerWidth = this.params.windowRect.width - this.params.leftBorderWidth - this.params.rightBorderWidth;
		//let windowInnerHeight = this.params.windowRect.height - this.params.topBorderWidth - this.params.bottomBorderWidth;

		// this is now inner window size, reduced by border
		//let windowInnerRect = new PixelRect(this.params.leftBorderWidth, this.params.topBorderWidth, windowInnerWidth, windowInnerHeight);

		//// Log.Debug(this.logGroup, "Inner window rect (borders compensated): " + windowInnerRect.toString());

		let symbolWidth = Math.round(this.params.windowRect.width / this.config.playWindow.Width);
		// if (symbolWidth - Math.round(symbolWidth) != 0) {
		// 	Log.Error(this.logGroup, "Window width is not equally divisible by number of symbols: window width = " + this.params.windowRect.width + ", reels = " + this.config.windowSymbolsSize.width);
		// }

		let symbolHeight = Math.round(this.params.windowRect.height / this.config.playWindow.Height);
		// if (symbolHeight - Math.round(symbolHeight) != 0) {
		// 	Log.Error(this.logGroup, "Window height is not equally divisible by number of symbols: window height = " + this.params.windowRect.height + ", symbols = " + this.config.windowSymbolsSize.height);
		// }

		this.symbolSize = new Size(symbolWidth, symbolHeight);

		//console.log("Symbol size", this.symbolSize);
		this.animationColumns = this.config.reelConfig.map(r => r.Col).filter((value, index, result) => result.indexOf(value) == index).sort((a, b) => a - b);

		// let inflatedWindowRect = this.InflateWindowRect(this.params.windowRect, this.params.windowRect);
		// this.slotWindowElement = CreateElement("div", {
		// 	classes: ["SpinnableReels2-SlotWindow"], style: {
		// 		position: "absolute",
		// 		left: inflatedWindowRect.x + "px",
		// 		top: inflatedWindowRect.y + "px",
		// 		width: inflatedWindowRect.width + "px",
		// 		height: inflatedWindowRect.height + "px",
		// 		//overflow: "hidden",
		// 	}
		// });

		this.sizes = this.ConstructReelSizes();

		// this.restoreWebGlInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 500, () => {
		// 	let success = this.tryRecoverWebglContext();

		// 	// success, stop timer
		// 	if (!success)
		// 	{
		// 		this.recoverFailCount++;

		// 		if (this.recoverFailCount == this.maxRecoverFailCount)
		// 		{
		// 		    void service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
		// 		}
		// 	}
		// });
	}

	public app: PIXI.Application<HTMLCanvasElement> = null;
	readonly sizes: ReelWindowSizes;




	protected ConstructReelSizes(): ReelWindowSizes
	{
		// prepare slot window
		const inflatedWindowRect = this.InflateWindowRect(this.params.windowRect, this.params.windowRect);
		const normalizedWindowRect: Rect = new Rect(
			this.params.windowRect.x - inflatedWindowRect.x,
			this.params.windowRect.y - inflatedWindowRect.y,
			this.params.windowRect.width,
			this.params.windowRect.height
		);	
		
		const reelWindowSizes: ReelWindowSizes = 
		{
			inflatedWindowRect: inflatedWindowRect,
			normalizedWindowRect: normalizedWindowRect,
			reelSizes: []
		};

		for (let index = 0; index < this.config.reelConfig.length; index++)
		{
			const reelConfig = this.config.reelConfig[index];

			const animationColumnIndex = this.animationColumns.indexOf(reelConfig.Col);


			const reelRect_symbols: Rect = new Rect(
				reelConfig.Col,
				reelConfig.Row,
				reelConfig.ColSpan,
				reelConfig.RowSpan
			);

			const reelRect_pixels: Rect = new Rect(
				reelRect_symbols.x * this.symbolSize.Width,
				reelRect_symbols.y * this.symbolSize.Height,

				reelRect_symbols.width * this.symbolSize.Width,
				reelRect_symbols.height * this.symbolSize.Height
			);

			const rowsPerSymbol = reelConfig.RowSpan / reelConfig.Height;
			const row = reelConfig.Row - (rowsPerSymbol * (reelConfig.ExtraSymbolsAbove || 0));
			const rowSpan = reelConfig.RowSpan + (rowsPerSymbol * (reelConfig.ExtraSymbolsAbove || 0));
			const heightInSymbols = reelConfig.Height + (reelConfig.ExtraSymbolsAbove || 0);

			const reelRectExtraSymbols_symbols = new Rect(
				reelConfig.Col,
				row,
				reelConfig.ColSpan,
				rowSpan
			);

			const reelRectExtraSymbols_pixels: Rect = new Rect(
				reelRectExtraSymbols_symbols.x * this.symbolSize.Width,
				reelRectExtraSymbols_symbols.y * this.symbolSize.Height,

				reelRectExtraSymbols_symbols.width * this.symbolSize.Width,
				reelRectExtraSymbols_symbols.height * this.symbolSize.Height
			);

			const inflatedReelRect = this.InflateReelRect(reelRectExtraSymbols_pixels, reelRectExtraSymbols_pixels);
			const normalizedReelRect = new Rect(
				reelRectExtraSymbols_pixels.x - inflatedReelRect.x,
				reelRectExtraSymbols_pixels.y - inflatedReelRect.y,
				reelRectExtraSymbols_pixels.width,
				reelRectExtraSymbols_pixels.height
			);

			const symbolSizePixels = new Size(
				normalizedReelRect.width,
				normalizedReelRect.height / heightInSymbols
			);

			let reelDisplayGeometry = {
				symbolsAbove: heightInSymbols + this.numAdditionalRowsTop,
				symbolsBelow: this.numAdditionalRowsBottom,
				symbolsTotal: heightInSymbols + this.numAdditionalRowsTop + this.numAdditionalRowsBottom
			};

			reelWindowSizes.reelSizes.push({
				animationColumnIndex: animationColumnIndex,
				reelRect_symbols: reelRect_symbols,
				reelRect_pixels: reelRect_pixels,
				reelRectExtraSymbols_symbols: reelRectExtraSymbols_symbols,
				reelRectExtraSymbols_pixels: reelRectExtraSymbols_pixels,
				heightInSymbols: heightInSymbols,
				reelDisplayGeometry: reelDisplayGeometry,
				inflatedReelRect: inflatedReelRect,
				normalizedReelRect: normalizedReelRect,
				symbolSizePixels: symbolSizePixels,
				reelConfig: reelConfig,
				symbolSizes: []
			});

			for (let s = 0; s < reelDisplayGeometry.symbolsTotal; s++)
			{
				const reverseRow = reelDisplayGeometry.symbolsTotal - 1 -  s;

				const originalSymbolRect: Rect = new Rect(
					0,
					(reverseRow - this.numAdditionalRowsTop) * reelWindowSizes.reelSizes[index].symbolSizePixels.Height,
					reelWindowSizes.reelSizes[index].symbolSizePixels.Width,
					reelWindowSizes.reelSizes[index].symbolSizePixels.Height
				);


				const absoluteSymbolRect: Rect = new Rect(
					this.params.windowRect.x + reelRectExtraSymbols_pixels.x + originalSymbolRect.x,
					this.params.windowRect.y + reelRectExtraSymbols_pixels.y + originalSymbolRect.y,
					originalSymbolRect.width,
					originalSymbolRect.height
				);

				reelWindowSizes.reelSizes[index].symbolSizes.push({
					originalSymbolRect: originalSymbolRect,
					absoluteSymbolRect: absoluteSymbolRect
				});
			}	
		};



		return reelWindowSizes;
	}

	//public isContexCrash = false ;		
	protected ConstructReels() {
	
		//create innerSlotWindowElement 
		
		let containerSpinnableReels2ViewAppBonus = new PIXI.Container();
		containerSpinnableReels2ViewAppBonus.width = Settings.ScreenWidth;
		containerSpinnableReels2ViewAppBonus.height = Settings.ScreenHeight;
		containerSpinnableReels2ViewAppBonus.x = 0;
		//if(this.reelsCoverAnotherScreen == false) containerSpinnableReels2ViewAppBonus.y = Settings.ScreenHeight * (Settings.Screens - 1);
		containerSpinnableReels2ViewAppBonus.name = "containerSpinnableReels2ViewAppBonus";
		this.containerReelsApp.addChild(containerSpinnableReels2ViewAppBonus);
		

		//create innerSlotWindowElement 
		let inflatedWindowRect = this.InflateWindowRect(this.params.windowRect, this.params.windowRect);
		let innerSlotWindowElement = new PIXI.Container();
		innerSlotWindowElement.width = this.sizes.normalizedWindowRect.width;
		innerSlotWindowElement.height = this.sizes.normalizedWindowRect.height;
		innerSlotWindowElement.x = inflatedWindowRect.x;
		innerSlotWindowElement.y = inflatedWindowRect.y;
		innerSlotWindowElement.name = "spinableReelsAppViewContainer";
		


		containerSpinnableReels2ViewAppBonus.addChild(innerSlotWindowElement);

		
		this.symbolElements = [];
		this.symbolsInColumn = new Array(this.animationColumns.length);
		this.reelsInAnimationColumn = new Array(this.animationColumns.length);

		const AspectFixY = 1; //ParseMonitors().AspectFixY;

		for (let index = 0; index < this.config.reelConfig.length; index++)
		{
			let reelConfig = this.config.reelConfig[index];

			//create config for reels 
			
			let animationColumnIndex = this.animationColumns.indexOf(reelConfig.Col);


			// let reelRect_symbols = new PixelRect(
			// 	reelConfig.Col,
			// 	reelConfig.Row,
			// 	reelConfig.ColSpan,
			// 	reelConfig.RowSpan
			// );

			// let reelRect_pixels: PixelRect = new PixelRect(
			// 	reelRect_symbols.x * this.symbolSize.width,
			// 	reelRect_symbols.y * this.symbolSize.height,

			// 	reelRect_symbols.width * this.symbolSize.width,
			// 	reelRect_symbols.height * this.symbolSize.height
			// );

			// TODO take into account additional symbol above
			// let rowsPerSymbol = reelConfig.RowSpan / reelConfig.Height;
			// let row = reelConfig.Row - (rowsPerSymbol * (reelConfig.ExtraSymbolsAbove || 0));
			// let rowSpan = reelConfig.RowSpan + (rowsPerSymbol * (reelConfig.ExtraSymbolsAbove || 0));
			// //let heightInSymbols = reelConfig.Height + (reelConfig.ExtraSymbolsAbove || 0);

			// let reelRectExtraSymbols_symbols = new PixelRect(
			// 	reelConfig.Col,
			// 	row,
			// 	reelConfig.ColSpan,
			// 	rowSpan
			// );

			// let reelRectExtraSymbols_pixels: PixelRect = new PixelRect(
			// 	reelRectExtraSymbols_symbols.x * this.symbolSize.width,
			// 	reelRectExtraSymbols_symbols.y * this.symbolSize.height,

			// 	reelRectExtraSymbols_symbols.width * this.symbolSize.width,
			// 	reelRectExtraSymbols_symbols.height * this.symbolSize.height
			// );

			//console.log("Reel " + reelConfig.Name, reelRectExtraSymbols_pixels);


			// let inflatedReelRect = this.InflateReelRect(reelRectExtraSymbols_pixels, reelRectExtraSymbols_pixels);
			// let normalizedReelRect = new PixelRect(
			// 	reelRectExtraSymbols_pixels.x - inflatedReelRect.x,
			// 	reelRectExtraSymbols_pixels.y - inflatedReelRect.y,
			// 	reelRectExtraSymbols_pixels.width,
			// 	reelRectExtraSymbols_pixels.height
			// );

			// let symbolSize = new Size(
			// 	normalizedReelRect.width,
			// 	normalizedReelRect.height / heightInSymbols
			// );

			let backgroundRect_symbols = this.sizes.reelSizes[index].reelRect_symbols;
			let backgroundRect_pixels  = this.sizes.reelSizes[index].reelRect_pixels;

			// TODO MAKE SETTINGS FOR THIS
			// include extra symbols
			backgroundRect_symbols = this.sizes.reelSizes[index].reelRectExtraSymbols_symbols;
			backgroundRect_pixels  = this.sizes.reelSizes[index].reelRectExtraSymbols_pixels;

			//missing fix reel background img
			//let texture = PIXI.Texture.from(this.params.backgroundImage.name);
			//create backgroud 
			let backgroundElement = new PIXI.Sprite(PIXI.Texture.WHITE);			
			backgroundElement.x = backgroundRect_pixels.x ;
			backgroundElement.y = backgroundRect_pixels.y ;
			backgroundElement.width = backgroundRect_pixels.width ;
			backgroundElement.height = backgroundRect_pixels.height ;
			backgroundElement.zIndex = ZIndex.ReelContainerBackground;
			backgroundElement.name = "BackgorundElement";
			innerSlotWindowElement.addChild(backgroundElement);

			//create reel Window Element
			let reelWindowElement = new PIXI.Container();			
			reelWindowElement.x = this.sizes.reelSizes[index].inflatedReelRect.x ;
			reelWindowElement.y = this.sizes.reelSizes[index].inflatedReelRect.y ;
			reelWindowElement.width = this.sizes.reelSizes[index].inflatedReelRect.width ;
			reelWindowElement.height = this.sizes.reelSizes[index].inflatedReelRect.height ;	
			reelWindowElement.zIndex = ZIndex.ReelContainer;	
			reelWindowElement.name = "reelWindowElement";
			innerSlotWindowElement.addChild(reelWindowElement);

			

			//normalizedReelWindowElement			
			let normalizedReelWindowElement = new PIXI.Container();			
			normalizedReelWindowElement.x = this.sizes.reelSizes[index].normalizedReelRect.x ;
			normalizedReelWindowElement.y = this.sizes.reelSizes[index].normalizedReelRect.y ;
			normalizedReelWindowElement.width = this.sizes.reelSizes[index].normalizedReelRect.width;
			normalizedReelWindowElement.height = this.sizes.reelSizes[index].normalizedReelRect.height;			
			normalizedReelWindowElement.name = "normalizedReelWindowElement";		
			reelWindowElement.addChild(normalizedReelWindowElement);			

			// let spinMaskRect = new PixelRect(
			// 	this.params.leftBorderWidth,
			// 	this.params.topBorderWidth,
			// 	normalizedReelRect.width - this.params.leftBorderWidth - this.params.rightBorderWidth,
			// 	normalizedReelRect.height - this.params.topBorderWidth - this.params.bottomBorderWidth
			// );
			//normalizedReelWindowElement.addChild(normalizedReelWindowElementBAck);
			//create mask 
			let spinMaskWindow = new PIXI.Sprite(PIXI.Texture.EMPTY);	
			spinMaskWindow.x = this.sizes.reelSizes[index].normalizedReelRect.x ;
			spinMaskWindow.y = this.sizes.reelSizes[index].normalizedReelRect.y;
			spinMaskWindow.width = this.sizes.reelSizes[index].normalizedReelRect.width;
			spinMaskWindow.height = this.sizes.reelSizes[index].normalizedReelRect.height;	
			spinMaskWindow.name = "spinMaskWindow";		
			spinMaskWindow.visible = true;		
			normalizedReelWindowElement.addChild(spinMaskWindow);

	

			

			let reelElement = new PIXI.Container();	
			reelElement.x = this.sizes.reelSizes[index].normalizedReelRect.x;
			reelElement.y = this.sizes.reelSizes[index].normalizedReelRect.y;
			reelElement.width = this.sizes.reelSizes[index].normalizedReelRect.width;
			reelElement.height = this.sizes.reelSizes[index].normalizedReelRect.height;	
			reelElement.name = "reelElement";		
			reelElement.mask = spinMaskWindow;					
			normalizedReelWindowElement.addChild(reelElement);	
		
			let bottomHiddenSymbols = new PIXI.Container();
			bottomHiddenSymbols.x = 0;	
			bottomHiddenSymbols.name = "bottomHiddenSymbols";		
			bottomHiddenSymbols.width = this.sizes.reelSizes[index].normalizedReelRect.width;
			bottomHiddenSymbols.height = this.sizes.reelSizes[index].normalizedReelRect.height;	
			reelElement.addChild(bottomHiddenSymbols);

			let middleVisibleSymbols = new PIXI.Container();
			middleVisibleSymbols.x = 0;			
			middleVisibleSymbols.name = "middleVisibleSymbols";	
			middleVisibleSymbols.width = this.sizes.reelSizes[index].normalizedReelRect.width;
			middleVisibleSymbols.height = this.sizes.reelSizes[index].normalizedReelRect.height;	
			reelElement.addChild(middleVisibleSymbols);

			let topHiddenSymbols = new PIXI.Container();
			topHiddenSymbols.x = 0;			
			topHiddenSymbols.name = "topHiddenSymbols";	
			topHiddenSymbols.width = this.sizes.reelSizes[index].normalizedReelRect.width;
			topHiddenSymbols.height = this.sizes.reelSizes[index].normalizedReelRect.height;	
			reelElement.addChild(topHiddenSymbols);

			


			let spinnableReel: S2_ISpinnableReelPIXI = {
				Config: reelConfig,

				ReelRect: this.sizes.reelSizes[index].reelRectExtraSymbols_pixels,
				//ReelWindowElement: reelWindowElement,
				BackgroundRect_symbols: backgroundRect_symbols,
				BackgroundRect_pixels: backgroundRect_pixels,
				
				WindowBackgroundElement: backgroundElement,
				ReelWindowElement: reelWindowElement,
				SpinMaskElement: spinMaskWindow,
				NormalizedWindowElement: normalizedReelWindowElement,
				ReelElement: reelElement,

				TopHiddenSymbols: topHiddenSymbols,
				MiddleVisibleSymbols: middleVisibleSymbols,
				BottomHiddenSymbols: bottomHiddenSymbols,

				SymbolSizeInPixels: this.sizes.reelSizes[index].symbolSizePixels,
				

				AbsoluteSymbolRects: new Map<number, Rect>(),
				ReelDisplayGeometry: this.sizes.reelSizes[index].reelDisplayGeometry,
				// ReelDisplayGeometry: {
				// 	symbolsAbove: heightInSymbols + this.numAdditionalRowsTop,
				// 	symbolsBelow: this.numAdditionalRowsBottom,
				// 	symbolsTotal: heightInSymbols + this.numAdditionalRowsTop + this.numAdditionalRowsBottom
				// },

				// will be set in loop below
				Canvases: [],
				CanvasesPIXI : [],
				NormalizedOriginalCanvasRect: null,
				OriginalSymbolSize: null,
				InflatedSymbolSize: null,

				originalSymbolScaleX: 1,
				originalSymbolScaleY: 1,
				originalSymbolScale: 1,

				inflatedSymbolScaleX: 1,
				inflatedSymbolScaleY: 1,
				inflatedSymbolScale: 1,

				// TODO take into account additional symbol showing on top
				// ReelDisplayGeometry: {
				// 	symbolsAbove: reelConfig.Height + (reelConfig.ExtraSymbolsAbove || 0) + this.numAdditionalRowsTop,
				// 	symbolsBelow: this.numAdditionalRowsBottom,
				// 	symbolsTotal: reelConfig.Height + (reelConfig.ExtraSymbolsAbove || 0) + this.numAdditionalRowsTop + this.numAdditionalRowsBottom
				// }
			};
			
			this.pixiCanvas[index] = [];
			this.pixiContainercanvas[index] = [];


			if (!this.reels) this.reels = [];
			this.reels.push(spinnableReel);

			if (!this.reelsInAnimationColumn[animationColumnIndex]) this.reelsInAnimationColumn[animationColumnIndex] = [];
			this.reelsInAnimationColumn[animationColumnIndex].push(spinnableReel);

			for (let s = 0; s < spinnableReel.ReelDisplayGeometry.symbolsTotal; s++)
			{
				//let reverseRow = spinnableReel.ReelDisplayGeometry.symbolsTotal - 1 -  s;

				// let originalSymbolRect: PixelRect = new PixelRect(
				// 	0,
				// 	(reverseRow - this.numAdditionalRowsTop) * this.sizes.reelSizes[index].symbolSizePixels.height,
				// 	this.sizes.reelSizes[index].symbolSizePixels.width,
				// 	this.sizes.reelSizes[index].symbolSizePixels.height
				// );


				// let absoluteSymbolRect: PixelRect = new PixelRect(
				// 	this.params.windowRect.x + reelRectExtraSymbols_pixels.x + originalSymbolRect.x,
				// 	this.params.windowRect.y + reelRectExtraSymbols_pixels.y + originalSymbolRect.y,
				// 	originalSymbolRect.width,
				// 	originalSymbolRect.height
				// );

				// spinnableReel.AbsoluteSymbolRects.set(reverseRow - this.numAdditionalRowsTop, absoluteSymbolRect);
				let preparedSymbolRect = this.PrepareSymbolRect(this.sizes.reelSizes[index].symbolSizes[s].originalSymbolRect);
				let inflatedSymbolRect = this.InflateSymbolRect(this.sizes.reelSizes[index].symbolSizes[s].originalSymbolRect, preparedSymbolRect);

				if (s == 0)
				{
					spinnableReel.NormalizedOriginalCanvasRect = new Rect(
						preparedSymbolRect.x - inflatedSymbolRect.x,
						preparedSymbolRect.y - inflatedSymbolRect.y,
						preparedSymbolRect.width,
						preparedSymbolRect.height
					);

					spinnableReel.OriginalSymbolSize = preparedSymbolRect.Size();
					spinnableReel.InflatedSymbolSize = inflatedSymbolRect.Size();

					spinnableReel.originalSymbolScaleX = spinnableReel.OriginalSymbolSize.Width / spinnableReel.InflatedSymbolSize.Width;
					spinnableReel.originalSymbolScaleY = spinnableReel.OriginalSymbolSize.Height / spinnableReel.InflatedSymbolSize.Height;
					spinnableReel.originalSymbolScale = Math.min(spinnableReel.originalSymbolScaleX, spinnableReel.originalSymbolScaleY);

					spinnableReel.inflatedSymbolScaleX = 1;
					spinnableReel.inflatedSymbolScaleY = 1;
					spinnableReel.inflatedSymbolScale  = 1;

					//// Log.Debug(this.logGroup, `Constructing reel ${reelConfig.Index} symbol ${s} rect: ${spinnableReel.NormalizedOriginalCanvasRect.toString()}`);
				}
				
				let parent: PIXI.Container;

				if (s < this.numAdditionalRowsBottom)
				{
					parent = spinnableReel.BottomHiddenSymbols;
				}
				else if (s > spinnableReel.ReelDisplayGeometry.symbolsTotal - this.numAdditionalRowsTop -1)
				{
					parent = spinnableReel.TopHiddenSymbols;
				}
				else
				{
					parent = spinnableReel.MiddleVisibleSymbols;
				}				

				//let alienImages = ["image_sequence_01.png", "image_sequence_02.png", "image_sequence_03.png", "image_sequence_04.png"];
				// let textureArray = [];
				// for (let i = 0; i < 4; i++) {
				// 	let texture = PIXI.Texture.WHITE;
				// 	textureArray.push(texture);
				// };
				let symbolElement = new PIXI.Container();
				symbolElement.x = inflatedSymbolRect.x;
				symbolElement.y = inflatedSymbolRect.y;			
				symbolElement.accessibleChildren = true;
				symbolElement.accessible = true;
				symbolElement.name = 'symbol';
				symbolElement.scale.set(1, AspectFixY);
				parent.addChild(symbolElement);

				let emptyCanvas = new PIXI.Sprite(PIXI.Texture.WHITE);								
				emptyCanvas.name = 'symbol';				
				symbolElement.addChildAt(emptyCanvas, 0);

				//create container for SRA value 				
				let shadowText = new PIXI.Text('');
				shadowText.x = Math.round((this.sizes.reelSizes[index].normalizedReelRect.width) / 2);
				shadowText.y = Math.round(this.sizes.reelSizes[index].normalizedReelRect.height / 2);
				shadowText.name = "SRAshadowText";
				symbolElement.addChildAt(shadowText, 1);

				//create container for SRA value 				
				let value = new PIXI.Text('');
				//value.width = this.symbolSize.width / 2;
				//value.height = this.symbolSize.height / 3.5;
				value.x = Math.round((this.sizes.reelSizes[index].normalizedReelRect.width) / 2);
				value.y = Math.round(this.sizes.reelSizes[index].normalizedReelRect.height / 2);
				value.name = "SRAvalue";
				symbolElement.addChildAt(value, 2);


				// create a new Sprfite from an image path.
				let jpImg = new PIXI.Sprite();
				jpImg.width = this.sizes.reelSizes[index].normalizedReelRect.width / 2;
				jpImg.height = this.sizes.reelSizes[index].normalizedReelRect.height / 5;
				jpImg.x = Math.round((this.sizes.reelSizes[index].normalizedReelRect.width) / 2);
				jpImg.y = Math.round(this.sizes.reelSizes[index].normalizedReelRect.height / 2);
				jpImg.name = "SRAjackpot";
				symbolElement.addChildAt(jpImg, 3);

				

				spinnableReel.CanvasesPIXI.push(symbolElement );
				this.pixiContainercanvas[index][s] = symbolElement ;
				this.pixiCanvas[index][s] = emptyCanvas;


				this.symbolElements.push(symbolElement);
				
				if (!this.symbolsInColumn[animationColumnIndex]) this.symbolsInColumn[animationColumnIndex] = [];
				this.symbolsInColumn[animationColumnIndex].push(symbolElement);
			}

		};

		this.maxSymbolHeightInPixels = this.reels.map(r => r.NormalizedOriginalCanvasRect.height).reduce((max, val) => max = Math.max(max, val), 0);
		this.maxReelHeightInSymbols = this.reels.map(r => r.Config.Height).reduce((max, val) => max = Math.max(max, val), 0);
	}

	public LoadedCanvasPIXI() {		
		//console.log("frameByGamesS&H:", framesGame);

		//create canvas symbols pixi.js
		for (let reelIndex = 0; reelIndex < this.pixiContainercanvas.length; reelIndex++) {
			for (let rowIndex = 0; rowIndex < this.pixiContainercanvas[reelIndex].length; rowIndex++) {			
				this.pixiCanvas[reelIndex][rowIndex].name = "symbol";				
				this.pixiCanvas[reelIndex][rowIndex].position.set((this.sizes.reelSizes[reelIndex].normalizedReelRect.width  )/ 2 , (this.sizes.reelSizes[reelIndex].normalizedReelRect.height ) / 2);
				this.pixiCanvas[reelIndex][rowIndex].anchor.set(0.5,0.5);
			}
		}	
	}

	protected PrepareSymbolRect(originalSymbolRect: Rect): Rect
	{

		// return as it is
		return originalSymbolRect;

		// turn into perfect rectangle
		let minSide = Math.min(originalSymbolRect.width, originalSymbolRect.height);

		let topOffset = (originalSymbolRect.height - minSide) / 2;
		let leftOffset = (originalSymbolRect.width - minSide) / 2;

		return new Rect(
			originalSymbolRect.x + leftOffset,
			originalSymbolRect.y + topOffset,
			minSide,
			minSide
		);
	}
	protected InflateSymbolRect(originalSymbolRect: Rect, preparedSymbolRect: Rect): Rect
	{
		// inflate by 5%
		//return preparedSymbolRect.Inflate(new Size(preparedSymbolRect.width * 0.05, preparedSymbolRect.height * 0.05));
		return preparedSymbolRect;
	}

	protected InflateWindowRect(originalWindowRect: Rect, preparedWindowRect: Rect): Rect
	{
		//return originalWindowRect;
		return this.InflateSymbolRect(originalWindowRect, preparedWindowRect);
	}

	protected InflateReelRect(originalReelRect: Rect, preparedReelRect: Rect): Rect
	{
		return originalReelRect;
	}

	/** window size in pixels */
	public GetWindowSize(): Size {
		return this.params.windowRect.Size();
	}

    public GetWindowSymbolSize(): PlayWindow {
		return this.config.playWindow;
        //throw new Error("Method not implemented.");
    }
   public GetSymbolSize(): Size {
		return this.symbolSize;
        //throw new Error("Method not implemented.");
    }
    public GetWindowRect(): Rect {
		return this.params.windowRect;
        //throw new Error("Method not implemented.");
    }
    public GetSymbolRect(column: number, row: number): Rect {
			// TODO
			return new Rect(
				this.params.windowRect.x + (column * this.symbolSize.Width),
				this.params.windowRect.y + (row * this.symbolSize.Height),
				this.symbolSize.Width,
				this.symbolSize.Height
			);
        //throw new Error("Method not implemented.");
    }
	public GetAbsoluteSymbolRectReelRow(reel: number, rowOnReel: number): Rect {

		let extraSymbolsAbove = this.config.reelConfig[reel].ExtraSymbolsAbove;
		return this.sizes.reelSizes[reel].symbolSizes[(extraSymbolsAbove || 0) + rowOnReel].absoluteSymbolRect;
    }
    public CanvasesReelRow(): MyCanvas[][] {
		return this.canvas;
        //throw new Error("Method not implemented.");
    }

	public GetMaxReelHeightInSymbols(): number
	{
		return this.maxReelHeightInSymbols;
	}

	public GetAnimationColumns(): number[]
	{
		return this.animationColumns;
	}

	public GetReelsInAnimationColumn(animationColumnIndex: number): S2_ISpinnableReelPIXI[]
	{
		assertNotNullish(this.reelsInAnimationColumn, "this.reelsInAnimationColumn is null");
		assertNotNullish(this.reelsInAnimationColumn[animationColumnIndex], "this.reelsInAnimationColumn[animationColumnIndex] is null");

		return this.reelsInAnimationColumn[animationColumnIndex];
		//return null
	}

	public GetSymbolSizePixels2(animationColumnIndex: number, symbolIndex: number): Size
	{
		return this.sizes.reelSizes.find(r => r.animationColumnIndex == animationColumnIndex)?.reelRect_pixels.Size();
	}

	public GetReels(): S2_ISpinnableReelPIXI[]
	{
		return this.reels;
	}
	
	public GetReel(reelIndex: number): S2_ISpinnableReelPIXI
	{
		return this.reels[reelIndex];
	}

	public GetReelDisplayGeometry(reelIndex: number): S2_SpinnableReelDisplayGeometry
	{
		return this.sizes.reelSizes[reelIndex].reelDisplayGeometry;
	}

	public GetView(): HTMLElement {
		return this.slotWindowElement;
	}

	public GetReelConfig(): S2_IReelConfig[]
	{
		return this.config.reelConfig;
	}

	public GetSymbolsInColumn(columnIndex: number): PIXI.Container[]
	{
		return this.symbolsInColumn[columnIndex];
	}
	
	//change resource for draw new symbol 
	public draw(reelIndex: number, rowIndex: number, symbolsToDraw: string) {
		//console.log("SymbolToDraw:", symbolsToDraw);
		//this.pixicanvas[reelIndex][rowIndex].textures = this.params.spritesByName.get("Symbol_" + symbolsToDraw);
		//this.symbolElements[reelIndex][rowIndex].textures = this.params.spritesByName.get("Symbol_" + symbolsToDraw);
	}

	// No extended symbols!
	public GetSymbolAt(col: number, row: number): S2_SymbolTranslation
	{
		// let reel = this.GetReelAt(col, row);
		// let reverserow = this.config.windowSymbolsSize.height - 1 - row;
		
		// let translatedRow = Math.floor((reverserow - reel.Config.Row) * reel.Config.Height / reel.Config.RowSpan);// + reel.Config.ExtraSymbolsAbove;

		// return {
		// 	reelIndex: reel.Config.Index,
		// 	rowIndex: translatedRow,
		// 	reel: reel
		// };
		throw 'its not implemented';
	}

	public GetReelAt(col: number, row: number): S2_ISpinnableReelPIXI
	{
		// TODO create cache for each position
		let reels = this.reels.filter(r => 
			col >= r.Config.Col && col < r.Config.Col + r.Config.ColSpan &&
			row >= r.Config.Row && row < r.Config.Row + r.Config.RowSpan);

		return reels[0] || null;
	}

	//update canvas render 
	public Update() {
		//this.app?.ticker?.update();
	}

    protected created: boolean = false;
    public Destroy()
    {
        
        this.InternalDestroy();
        this.created = false;
		//this.restoreWebGlInterval.Stop();
    }

	protected InternalDestroy() {

		if (!this.created)
		{
			Log.Debug(this.logGroup, `Destroy(): no app, not destroying anything`);
			return;
		}

		// Log.Debug(this.logGroup, `Destroy(): destroying`);

		// reset arrays
		Safe(() => this.pixiCanvas = []);
		Safe(() => this.pixiContainercanvas = []);
		Safe(() => this.symbolsInColumn = []);
		Safe(() => this.symbolElements = []);
		Safe(() => this.reelsInAnimationColumn = []);
		Safe(() => this.reels = []);
		Safe(() =>{
			this.containerReelsApp.removeChildren();
			this.containerReelsApp.removeFromParent();
		});
	}


    public Create(containerReelsApp : PIXI.Container )
    {
		this.containerReelsApp = containerReelsApp;
        this.created = true;
		
		{
        	this.InternalCreate();
		}
		
			//this.restoreWebGlInterval.Start();
    }


	protected containerReelsApp : PIXI.Container = null;
	protected InternalCreate()
	{
		if (!this.created)
		{
			Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
			return;
		}
	
		//if(this.reelsCoverAnotherScreen == false) this.containerReelsApp.y = Scale.Y(1080) * (Settings.Screens - 1); 
		
		//create Reels view 
		this.ConstructReels();
		this.LoadedCanvasPIXI();

		this.OnCreatedCallback?.();
	}

	// protected recoverCount: number = 0;
	// protected recoverFailCount: number = 0;
    // protected readonly maxRecoverFailCount = 5;

	// protected tryRecoverWebglContext(): boolean
	// {
	// 	if (!this.created)
	// 	{
	// 		this.restoreWebGlInterval.Stop();
	// 		this.recoverFailCount = 0;

	// 		// app not created, don't care
	// 		return true;
	// 	}

	// 	console.log(this.resid.ID() + " trying to recover");
	//     void service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
	// 	try
	// 	{
	// 	    void service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
	// 		this.InternalDestroy();
	// 	    void service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
	// 	}
	// 	catch (ex)
	// 	{
	// 	    void service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
	// 	}

	// 	try
	// 	{
	// 		// Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
	// 	    void service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
	// 		this.InternalCreate();

	// 		// all fine, stop timer
	// 		this.restoreWebGlInterval.Stop();
    //         console.log(this.resid.ID() + " recover success");

	// 		this.recoverCount++;
	// 		this.restoreWebGlInterval.Stop();
	// 		this.recoverFailCount = 0;

	// 	    void service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
	// 	    void service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

	// 		return true;
	// 	}
	// 	catch (ex)
	// 	{
    //         console.log(this.resid.ID() + " error recovering", ex);

    //         // prevent spamming the backend
    //         if (this.recoverFailCount < this.maxRecoverFailCount)
    //         {
	// 		    void service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

    //             if (ex.message.toLowerCase().includes("this browser does not support webgl"))
    //             {
    //                    void service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
    //             }
    //             else
    //             {
    //                    void service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
    //             }
    //         }
	// 	}

	// 	return false;
	// };

	// protected webglcontextlost()
	// {
    //     Log.Error(this.logGroup, `Webgl context lost`);
	//     void service.api.frontendError(FrontendErrorCode.WebGLContextLost, "Webgl context lost");

	// 	// try recover right now, or start timer to try recover later
	// 	let success = this.tryRecoverWebglContext();
	// 	if (success)
	// 	{
	// 		// all good
	// 		return;
	// 	}
		
	// 	// error recovering, start timer
	// 	this.restoreWebGlInterval.Start();
	// }

    // protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);

	public OnCreatedCallback: OnCreatedCallbackHandler = null;
	
}

export type OnCreatedCallbackHandler = () => void;



interface ReelWindowSizes
{
	inflatedWindowRect: Rect;
	normalizedWindowRect: Rect;
	reelSizes: ReelSizes[];
}

interface ReelSizes
{
	animationColumnIndex: number;
	reelRect_symbols: Rect;
	reelRect_pixels: Rect;
	reelRectExtraSymbols_symbols: Rect;
	reelRectExtraSymbols_pixels: Rect;
	heightInSymbols: number;
	reelDisplayGeometry: S2_SpinnableReelDisplayGeometry;
	inflatedReelRect: Rect;
	normalizedReelRect: Rect;
	symbolSizePixels: Size;
	reelConfig: S2_IReelConfig;
	//absoluteSymbolRects: Map<number, Rect>;
	symbolSizes: SymbolSizes[]
}

interface SymbolSizes
{
	originalSymbolRect: Rect;
	absoluteSymbolRect: Rect;
}